var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mx-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":_vm.cols}},[_c('cusip-search-box'),_c('cusip-search-results')],1),(_vm.selectedProperty)?_c('v-col',{attrs:{"cols":6}},[_c('property-details')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }